import React, { useState, useEffect, useCallback } from "react";
import "./CommissionForm.css";
import { getCommissionAPI, updateCommissionAPI } from "../../../utils/APIs/commissionApis";
import { toast } from "react-toastify";

const CommissionForm = ({ role = "photographers", roleTitle = "Photographer" }) => {
  const [commission, setCommission] = useState({
    initio: "",
    elite: "",
    pro: "",
  });

  const [loading, setLoading] = useState(false);

  const fetchCommission = useCallback(async () => {
    try {
      setLoading(true);
      const response = await getCommissionAPI(role);

      const data = response?.data?.commissions;

      setCommission({
        initio: data?.initio || "",
        elite: data?.elite || "",
        pro: data?.pro || "",
      });
    } catch (error) {
      console.error("Failed to fetch commission:", error);
       setCommission({ initio: "", elite: "", pro: "" });
    } finally {
      setLoading(false);
    }
  }, [role]);

  // ✅ Fetch commission when component loads or role changes
  useEffect(() => {
    fetchCommission();
  }, [role, fetchCommission]);

const handleChange = (e) => {
  const { name, value } = e.target;

  // Prevent negative values
  if (value < 0) return;

  setCommission((prev) => ({
    ...prev,
    [name]: value,
  }));
};

  // ✅ Submit updated commission
const handleSubmit = async (e) => {
  e.preventDefault();

  // ✅ Validate empty values
  const isTwoTier = role === "editors";
  if (
    commission.initio === "" ||
    commission.elite === "" ||
    (!isTwoTier && commission.pro === "")
  ) {
    toast.error("All commission fields are required");
    return;
  }

  // ✅ Validate negative values
  if (
    commission.initio < 0 ||
    commission.elite < 0 ||
    (!isTwoTier && commission.pro < 0)
  ) {
    toast.error("Commission cannot be negative");
    return;
  }

  try {
    setLoading(true);

    const payload = {
      initio: Number(commission.initio),
      elite: Number(commission.elite),
      pro: isTwoTier ? 0 : Number(commission.pro),
    };

    const response = await updateCommissionAPI(role, payload);

    if (response?.status === 200 && response?.data?.success) {
      toast.success(
        response?.data?.message ||
        `${roleTitle} commission updated successfully!`
      );
    } else {
      toast.error(
        response?.data?.message ||
        "Commission not updated!"
      );
    }

  } catch (error) {
    console.error("Failed to update commission:", error);

    toast.error(
      error?.response?.data?.message ||
      "Failed to update commission"
    );

  } finally {
    setLoading(false);
  }
};

  return (
    <>
    <form className="commission-form" onSubmit={handleSubmit}>
      <div className="commission-card">
        <h3>
          {role === "editors" ? "STANDARD" : "INITIO"} {roleTitle}
        </h3>
        <div className="input-wrapper">
          <input
            type="number"
            name="initio"
            placeholder="Commission %"
            value={commission.initio}
            onChange={handleChange}
            min="0"
          />
        </div>
      </div>

      <div className="commission-card">
        <h3>
          {role === "editors" ? "PREMIUM" : "ELITE"} {roleTitle}
        </h3>
        <div className="input-wrapper">
          <input
            type="number"
            name="elite"
            placeholder="Commission %"
            value={commission.elite}
            onChange={handleChange}
            min="0"
          />
        </div>
      </div>

      {role !== "editors" && (
        <div className="commission-card">
          <h3>PRO {roleTitle}</h3>
          <div className="input-wrapper">
            <input
              type="number"
              name="pro"
              placeholder="Commission %"
              value={commission.pro}
              onChange={handleChange}
              min="0"
            />
          </div>
        </div>
      )}

      <div className="save-btn-container">
        <button type="submit" className="save-btn" disabled={loading}>
          {loading ? "Saving..." : `Save ${roleTitle} Commission`}
        </button>
      </div>
    </form>
    </>
  );
};

export default CommissionForm;


// import React, { useState } from "react";
// import "./CommissionForm.css"
// const CommissionForm = () => {
//   const [commission, setCommission] = useState({
//     basic: "",
//     intermediate: "",
//     professional: "",
//   });

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setCommission((prev) => ({
//       ...prev,
//       [name]: value,
//     }));
//   };

//   const handleSubmit = (e) => {
//     e.preventDefault();
//     console.log("Commission Settings:", commission);
//     // API call goes here
//   };

//   return (
    
//     <form className="commission-form" onSubmit={handleSubmit}>
//       <div className="commission-card">
//         <h3>Basic Photographer</h3>
//         <input
//           type="number"
//           name="basic"
//           placeholder="Commission %"
//           value={commission.basic}
//           onChange={handleChange}
//         />
//       </div>

//       <div className="commission-card">
//         <h3>Intermediate Photographer</h3>
//         <input
//           type="number"
//           name="intermediate"
//           placeholder="Commission %"
//           value={commission.intermediate}
//           onChange={handleChange}
//         />
//       </div>

//       <div className="commission-card">
//         <h3>Professional Photographer</h3>
//         <input
//           type="number"
//           name="professional"
//           placeholder="Commission %"
//           value={commission.professional}
//           onChange={handleChange}
//         />
//       </div>

//       <button type="submit" className="save-btn">
//         Save Commission
//       </button>
//     </form>
//   );
// };

// export default CommissionForm;
